import { Component, OnInit } from '@angular/core';
import { OktaService } from '../okta.service';
import {
  CacheConstant,
  OktaOperationType,
  CacheDuration
} from '../../../core/constants/app.constant';
import { OktaOperation } from '../okta-operation';
import { OktaRoutes } from '../../../core/constants/routes.constant';
import { AppUtilService } from '../../../core/utils/app-util.service';
import { OktaConstant } from '../okta.constant';
import { AppCacheService } from '../../../core/services/cache/app-cache.service';

@Component({
  selector: 'par-verify-token',
  templateUrl: './verify-token.component.html',
  styleUrls: ['./verify-token.component.scss']
})
export class VerifyTokenComponent implements OnInit {
  /***************Properties***************/
  private operation: OktaOperation;
  token: any = { expired: false, errorMessage: '' };
  websiteName: string = this.cache.get(CacheConstant.Env_Properties).theme;
  /***************Properties***************/

  /***************Constructor***************/
  constructor(private cache: AppCacheService, private oktaService: OktaService) {}

  ngOnInit() {
    this.operation = AppUtilService.cache.get(
      CacheConstant.Okta_Operation
    ) as OktaOperation;
    if (this.operation && this.operation.data && this.operation.data.token) {
      AppUtilService.cache.remove(CacheConstant.Okta_Operation);
      this.verifyToken();
    } else {
      AppUtilService.redirectToHome();
    }
  }
  /***************Constructor***************/

  /***************Private Methods***************/

  private verifyToken() {
    const token = this.operation.data.token;
    this.oktaService
      .verifyToken(this.operation.data.token)
      .subscribe((response: any) => {
        if (!response.hasError) {
          let urlToNavigate = null;
          switch (this.operation.type) {
            case OktaOperationType.ForgotPassword:
            case OktaOperationType.UnlockAccount:
              urlToNavigate = OktaRoutes.AnswerSecurityQuestion;
              break;

            case OktaOperationType.ActivateUser:
              urlToNavigate = OktaRoutes.ActivateUser;
              break;

            case OktaOperationType.ResetPwd:
              urlToNavigate = OktaRoutes.ResetPwd;
              break;

            default:
              break;
          }

          if (urlToNavigate) {
            response.verified = true;
            this.operation.data = response;
            this.operation.data.token = token;
            AppUtilService.cache.set(
              CacheConstant.Okta_Operation,
              this.operation,
              CacheDuration.OneMinute
            );

            AppUtilService.router.navigate([urlToNavigate]);
          }
        } else {
          this.token.expired = true;
          if(this.websiteName === 'Parmed') {
            this.token.errorMessage =
            this.operation.type === OktaOperationType.ActivateUser
              ? OktaConstant.Messages.ActivationTokenExpiredMessage
              : OktaConstant.Messages.TokenExpiredMessage;
          }
          else if(this.websiteName === 'Major') {
          this.token.errorMessage =
          this.operation.type === OktaOperationType.ActivateUser
            ? OktaConstant.Messages.MajorActivationTokenExpiredMessage
            : OktaConstant.Messages.TokenExpiredMessage;
         }
        }
      });
  }

  /***************Private Methods***************/
}
